<div class="container">
    <div class="mb-1 d-flex gap-4 row">
        <div class="col-12 col-md-3 col-xl-3 card-container">
            <div class="card text-white bg-primary mb-3" style="width: 18rem">
                <div class="card-body">
                    <h5 class="card-title">{{ 'software.business' | translate }}</h5>
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/notification']" routerLinkActive="active">
                            {{ 'menu_notification' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/version-info']" routerLinkActive="active">
                            {{ 'menu.version_info' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-md-3 col-xl-3 card-container" *ngIf="isAdmin">
            <div class="card text-white bg-success mb-3" style="width: 18rem">
                <div class="card-body">
                    <h5 class="card-title">{{ 'software.system' | translate }}</h5>
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/user-list']" routerLinkActive="active">
                            {{ 'menu.admin_user_list' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/system-parameter-list']" routerLinkActive="active">
                            {{ 'menu.system_parameter_list' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/language-list']" routerLinkActive="active">
                            {{ 'menu.language_list' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/email-list']" routerLinkActive="active">
                            {{ 'menu.email_list' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/frontend-display-html-list']" routerLinkActive="active">
                            {{ 'menu.frontend_display_html_list' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/resource-list']" routerLinkActive="active">
                            {{ 'menu.resource_list' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a class="nav-link link text-info display-4" [routerLink]="['/administration/business-log-list']" routerLinkActive="active">
                            {{ 'menu.business_log_list' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
